import { useLocation } from "react-router-dom";
import { ReactComponent as UpArrow } from "../../../iconColor/up-arrow.svg";
import { useState } from "react";

interface MenuItemProps {
  index: number;
  Menu: any;
  isSub?: boolean;
  activeMenu: any;
  handleMenuItemClick: any;
  open: boolean;
  subMenuOpen: any;
  setSubMenuOpen: any;
  haveSub?: any;
  title?: string;
}

const MenuItem: React.FC<MenuItemProps> = ({
  index,
  Menu,
  isSub = false,
  activeMenu,
  handleMenuItemClick,
  open,
  subMenuOpen,
  setSubMenuOpen,
  title,
}) => {
  const location = useLocation();
  const path = location.pathname;
  const [hover, setHover] = useState(false);

  const handleDragStart = (e: React.DragEvent) => {
    if (!Menu.disable && (!Menu.subMenus || isSub)) {
      e.dataTransfer.setData(
        "text/plain",
        JSON.stringify({
          id: Menu.id,
          content: Menu.title,
          icon: Menu.icon,
          src: Menu.src,
        })
      );
    } else {
      e.preventDefault();
    }
  };

  return (
    <li
      key={index}
      draggable={!Menu.disable && (!Menu.subMenus || isSub)}
      onDragStart={handleDragStart}
      onMouseEnter={() => !open && setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={
        !isSub
          ? `whitespace-nowrap ${
              Menu?.disable
                ? "text-gray-300 whitespace-nowrap " +
                  "hover:bg-gray-100 hover:text-gray-500"
                : "hover:bg-primary-200 text-gray-500"
            }
                    flex mx-3 rounded-md p-2 mb-4 ${
                      !Menu.icon && !open
                        ? "px-2"
                        : Menu.subMenus && !open
                        ? "px-0"
                        : ""
                    }  cursor-pointer text-Body-OneLine/16/Bold items-center ${
              open ? "gap-x-4" : "gap-x-"
            }  
                    ${
                      Menu.title === "خروج از حساب" ||
                      Menu.title === "بازگشت به پنل ادمین"
                        ? "hover:text-red-700 text-red-700 hover:bg-gray-100"
                        : "hover:bg-primary-200 hover:text-gray-900"
                    }
                    ${
                      activeMenu === Menu.src || path === Menu?.srcForNewTab
                        ? "bg-gray-100 text-gray-900 rounded-lg font-bold"
                        : ""
                    }`
          : `flex mx-6 cursor-pointer gap-x-1 mb-2 p-2 whitespace-nowrap hover:text-gray-900 hover:bg-primary-200 hover:rounded-lg 
                ${!Menu?.disable ? "text-gray-900" : "text-gray-200"} ${
              path === Menu?.srcForNewTab
                ? "text-gray-900 font-[900] bg-gray-100 rounded-lg"
                : ""
            }`
      }
      onClick={(e) => {
        if (e.ctrlKey || e.metaKey || e.button === 1) {
          window.open(Menu.srcForNewTab, "_blank");
        }
        handleMenuItemClick(Menu);
        if (Menu.subMenus) {
          if (subMenuOpen === Menu.src) {
            setSubMenuOpen("");
          } else {
            setSubMenuOpen(Menu.src);
          }
        }
      }}
      onContextMenu={(e) => {
        e.preventDefault();
        !Menu.subMenus && window.open(Menu.srcForNewTab, "_blank");
      }}
    >
      <span className="relative flex items-center">
        {Menu.icon}
        {!open && hover && (
          <span className="absolute right-full ml-2 bg-gray-700 text-white text-sm rounded-md px-2 py-1 shadow-lg z-[900]">
            {title ? title : Menu.title}
          </span>
        )}
      </span>
      <span className={`${open ? "" : "hidden"} my-auto flex-1`}>
        {title ? title : Menu.title}
      </span>
      <span
        className={` absolute left-full ml-2 bg-gray-700 text-white text-sm rounded-md px-2 py-1 shadow-lg ${
          open ? "" : "hidden"
        } flex-1`}
      >
        {title ? title : Menu.title}
      </span>

      {Menu.subMenus && (
        <UpArrow
          onClick={() => {
            if (subMenuOpen === Menu.src) {
              setSubMenuOpen("");
            } else {
              setSubMenuOpen(Menu.src);
            }
          }}
          className={`transition-all ${
            subMenuOpen === Menu.src ? "-rotate-180" : "-rotate-90"
          } ${open ? "gap-y-10" : "gap-x-10"}`}
        />
      )}
    </li>
  );
};

export default MenuItem;
